import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './_languages.table.scss';
import './_languages.table.dark-mode.scss'
import Head from './Head';
import Body from './Body';

const LanguagesTable = ({
  items,
  config,
  isLoading,
  onChangeVisibility,
  onSort,
}) => (
  <>
    <Table>
      <Head
        config={config}
      />
      <Body
        isLoading={isLoading}
        helperClass="languages-table__helper"
        useDragHandle={!!config?.access?.languages_edit_position}
        config={config}
        items={items}
        onSortEnd={onSort}
        onChangeVisibility={onChangeVisibility}
      />
    </Table>
  </>
);

LanguagesTable.propTypes = {
  items: PropTypes.array,
  config: PropTypes.object,
  isLoading: PropTypes.bool,
  onChangeVisibility: PropTypes.func,
  onSort: PropTypes.func,
};

export default LanguagesTable;
